import React from "react";

function Subscribe() {
  return (
    <div>
      <section class="bg-white ">
        <div class="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
          <div class="mx-auto max-w-screen-sm text-center">
            <h2 class="mb-4 text-4xl font-extrabold leading-tight text-blue-400 ">
              Subscribe Our Website
            </h2>
            <p class="mb-6 font-light text-gray-500  md:text-lg">
              Engage our blog and news post with{" "}
              <span className="text-blue-400 font-bold">Meklit </span>{" "}
              Humanitarian Association
            </p>

            <input
              class="text-gray-700 border border-blue-300   font-small rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 "
              placeholder="email"
              type="email"
            ></input>

            <a
              href="/"
              class=" text-white bg-blue-500 hover:bg-blue-400 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2  focus:outline-none"
            >
              Submit
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Subscribe;
